import {ActionTree, GetterTree, Module, MutationTree} from "vuex";
import {RootState} from "@/store/types";
import {AgreementGroupState, AgreementGroup} from "@/modules/agreement_group/types";
import {getAgreementGroup, getAgreementGroups} from "@/services/agreement_group";

export const state: AgreementGroupState = {
  agreementGroup: {
    id: 0,
    name: "",
  },
}

const actions: ActionTree<AgreementGroupState, RootState> = {
  async GET_AGREEMENT_GROUP(_, id) {
    return await getAgreementGroup(id);
  },
  async GET_AGREEMENT_GROUPS() {
    return await getAgreementGroups();
  }
}

const mutations: MutationTree<AgreementGroupState> = {
  SET_AGREEMENT_GROUP(state, agreementGroup: AgreementGroup){
    state.agreementGroup = agreementGroup
  }
}

const getters: GetterTree<AgreementGroupState, RootState> = {
  AGREEMENT_GROUP(state): AgreementGroup {
    const {agreementGroup} = state;
    return {...agreementGroup};
  }
}

export const agreement_group: Module<AgreementGroupState, RootState> = {
  state,
  actions,
  getters,
  mutations
}
